export const SORTING_VALUES = {
  createdAt: 'createdAt',
  lastname: 'lastname',
  sessionsCompleted: 'sessionsCompleted',
  sessionsAwaiting: 'sessionsAwaiting',
  name: 'name',
};

export enum SearchFilterKey {
  SearchValue = 'searchValue',
  SearchTerm = 'searchTerm',
}

export enum BooleanFilterKey {
  BooleanFilter = 'booleanFilter',
  PromocodeDomainBooleanFilter = 'booleanFilter.promocodeDomain',
  PromocodeTypeBooleanFilter = 'booleanFilter.promocodeType',
  PromocodeStatusBooleanFilter = 'booleanFilter.promocodeStatus',
}

const SEARCH_FILTER_KEYS: string[] = Object.values(SearchFilterKey);
const BOOLEAN_FILTER_KEYS: string[] = Object.values(BooleanFilterKey);
const FILTER_KEYS: string[] = SEARCH_FILTER_KEYS.concat(BOOLEAN_FILTER_KEYS);

export const isFilterKey = (key: string): key is SearchFilterKey | BooleanFilterKey => {
  return FILTER_KEYS.includes(key);
}

export const isSearchFilterKey = (key: string): key is SearchFilterKey => {
  return SEARCH_FILTER_KEYS.includes(key);
}

export const isBooleanFilterKey = (key: string): key is BooleanFilterKey => {
  return BOOLEAN_FILTER_KEYS.includes(key);
}


